import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/sharp-regular-svg-icons/faMinus';

import { WIDGET_TYPE } from './widget-type';
import { DOCUMENT_COLORS, intToHex } from '../properties-panel/widget-properties/document-colors';
import { FillColorProperty } from '../properties-panel/widget-properties/fill/fill';
import { HeightProperty } from '../properties-panel/widget-properties/height-input/height-input';
import { LineOrientationProperty } from '../properties-panel/widget-properties/line-orientation/line-orientation';
import { WidthProperty } from '../properties-panel/widget-properties/width-input/width-input';

import type { LineWidget, LineWidgetDefinition, WidgetConfig, WidgetProperties, WidgetProps } from '../config';

const lineDefinition: LineWidgetDefinition = {
  type: WIDGET_TYPE.line,
  ui: {
    label: 'Line',
    pickerElement: <FontAwesomeIcon icon={faMinus} />,
    minWidth: 1,
    minHeight: 1,
  },
  initialConfiguration: {
    width: 150,
    height: 2,
    fill: DOCUMENT_COLORS.black.int,
  },
};

const lineProperties: WidgetProperties<LineWidget> = [WidthProperty, HeightProperty, FillColorProperty, LineOrientationProperty];

const Line = ({ widget }: WidgetProps<LineWidget>) => {
  return <div style={{ backgroundColor: intToHex(widget.fill), height: '100%' }} />;
};

export const LineWidgetConfig: WidgetConfig<LineWidget> = {
  Component: Line,
  definition: lineDefinition,
  properties: lineProperties,
};
